import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import {
    MAT_BOTTOM_SHEET_DATA,
    MatBottomSheet,
    MatBottomSheetModule,
} from '@angular/material/bottom-sheet';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatNavList } from '@angular/material/list';
import { SiaTranslatePipe } from '@sia/shared';
import { SiaAction } from '../../interfaces/sia-action';
import { SiaActionsService } from '../../services/sia-actions.service';

@Component({
  selector: 'sia-action-bottom-sheet',
  templateUrl: './sia-action-bottom-sheet.component.html',
  styleUrls: ['./sia-action-bottom-sheet.component.scss'],
  standalone: true,
  imports: [
    MatNavList,
    MatBottomSheetModule,
    MatIcon,
    SiaTranslatePipe,
    MatIconButton,
    MatBadgeModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiaActionBottomSheetComponent {
  readonly data = inject(MAT_BOTTOM_SHEET_DATA);
  private bottomSheet = inject(MatBottomSheet);
  private actionsService = inject(SiaActionsService);

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {
    // console.log(this.data.actions);
  }
  closeBottomSheet() {
    this.bottomSheet.dismiss();
  }
  actionFired(action: SiaAction) {
    this.actionsService.fireSiaAction({
      action: action,
      guid: this.data.pageData.guid,
      componentId: this.data.pageData.componentId,
      componentParameters: this.data.componentParameters,
    });
    this.closeBottomSheet();
  }

  fireAction(action: SiaAction) {
    this.bottomSheet.dismiss(action);
  }

  ngOnInit(): void {}
}
